

























































































































































































































































































import IGoodsMovements from '@/store/models/IGoodsMovements';
import ICompany from '@/store/models/ICompany';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IWarehouse from '@/store/models/IWarehouse';
import IStock from '@/store/models/IStock';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import moment from 'moment';
import { delay, difference, uniq, without } from "lodash";
import IListStatusGoodsMovements from '../../../store/models/IListStatusGoodsMovements';

@Component({
    components: {
        Snackbar,
        FilterMenu
    }
})
export default class GoodsMovementsSelector extends Vue {
    menu2: boolean = false;
    searchMovement: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'date';
    sortDesc: boolean = true;
    headers: any = [
        { text: 'Company Warehouse Source',
            align: 'start',
            value: 'companySourceWarehouseName'
        },
        { text: 'Warehouse Name Source', value: 'warehouseSourceName' },
        { text: 'Code', value: 'code' },
        { text: 'Company Warehouse Destination', value: 'companyDestinationWarehouseName' },
        { text: 'Warehouse Name Destination', value: 'warehouseDestinationName' },
        { text: 'Date In', value: 'date' },
        { text: 'Status', value: 'statusName' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];

    headersStock: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Inbound', value: 'codeInbounds' },
        { text: 'Pallet Id', value: 'idPallet' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'BestBeforeDate', value: 'bestBeforeDate' },
        { text: 'Weight', value: 'weight' },
        { text: 'Reference dossier number', value: 'referenceInboundCode' }
    ];

    editedIndex : number = -1;
    editedItem : IGoodsMovements = {
        id: "",
        code: "",
        idCompanySourceWarehouse: "",
        companySourceWarehouseName: "",
        idWarehouseSource: "",
        warehouseSourceName: "",
        idCompanyDestinationWarehouse: "",
        companyDestinationWarehouseName: "",
        idWarehouseDestination: "",
        warehouseDestinationName: "",
        date: new Date(),
        description: "",
        idCustomer: ""
    }
    defaultItem : IGoodsMovements = {
        id: "",
        code: "",
        idCompanySourceWarehouse: "",
        companySourceWarehouseName: "",
        idWarehouseSource: "",
        warehouseSourceName: "",
        idCompanyDestinationWarehouse: "",
        companyDestinationWarehouseName: "",
        idWarehouseDestination: "",
        warehouseDestinationName: "",
        date: new Date(),
        description: "",
        idCustomer: ""
    }

    @Prop({ type: Array, required: true })
    CompanyList !: ICompany[];
    @Prop({ type: Array, required: true })
    MovementList !: IGoodsMovements[];
     @Prop({ type: Array, required: true })
    WarehouseList !: IWarehouse[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    StockCompanyList !: IStock[];
    @Prop()
    CompanySourceId !: string;
    @Prop()
    MovementCodeSelectedFromDashboard !: string;
    @Prop()
    value !: IGoodsMovements;
    @Prop({ type: Boolean, default: false })
    IsStandAlone !: boolean;

    selectedStockList : IStock[] = [];
    selectedMovement : IGoodsMovements[] = [];
    selectedCompanyWarehouseDestination : ICompany = {} as ICompany;
    selectedWarehouseCompanyDestination : IWarehouse = {} as IWarehouse;
    date: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    inboundCodeFilter : string[] = [];
    goodFilter : string[] = [];
    palletFilter : string[] = [];
    warehouseNameFilter : string[] = [];
    bestBeforeDateFilter : Date[] = [];
    selectedCompanyWarehouseSource : IWarehouse = {} as IWarehouse;
    selectedInboundCode: string = "";
    isInboundLocked: boolean = false;
    // selectedStatusGoodsMovements: IListStatusGoodsMovements = {} as IListStatusGoodsMovements;
    // showCompletedGoodsMovements: boolean = false;

    get formTitle() { return this.editedIndex === -1 ? 'New Movement' : 'Edit Movement'; }

    get DateFormatted() {
        return this.formatDate(this.date);
    }

    get filteredInboundCodes() {
        if (!this.selectedCompanyWarehouseSource || !this.selectedCompanyWarehouseSource.id) {
            return [];
        }

        // Filtra solo los inbounds del almacén source seleccionado
        const inboundList = this.StockCompanyList
        .filter(s => s.idWarehouse === this.selectedCompanyWarehouseSource.id && s.codeInbounds)
        .map(s => s.codeInbounds);

        // Quita duplicados
        const uniqueCodes = Array.from(new Set(inboundList));

        // Devuelve objetos con propiedad "codeInbounds" (para el v-select)
        return uniqueCodes.map(code => ({ codeInbounds: code }));
    }

    @Watch('selectedInboundCode')
    onSelectedInboundCodeChanged(newCode: string) {
        if (newCode && newCode.trim() !== '') {
            this.editedItem.code = newCode.trim();
        } else {
            this.editedItem.code = '';
        }
    }

    onInboundSelected(selected: { codeInbounds: string }) {
        if (selected && selected.codeInbounds) {
            this.selectedInboundCode = selected.codeInbounds;
        } else {
            this.selectedInboundCode = "";
        }
        this.selectedStockList = [];
    }

    customFilter(item: any, queryText: string, itemText: string): boolean {
        const text = itemText!.toString().toLowerCase() || "";
        const searchText = queryText.toLowerCase();
        return text.indexOf(searchText) > -1;
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate (date: string) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : IGoodsMovements | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedMovement = [];
        } else {
            this.selectedMovement = [newValue];
            this.$emit('onChangeSelectedMovement', this.selectedMovement);
        }
    }

    @Watch('selectedCompanyWarehouseDestination')
    onChangeSelectedCompanyDestination() {
        this.editedItem.idCompanyDestinationWarehouse = this.selectedCompanyWarehouseDestination.id;
        this.editedItem.companyDestinationWarehouseName = this.selectedCompanyWarehouseDestination.name;
    }

    @Watch('MovementCodeSelectedFromDashboard')
    onChangeMovementCodeSelectedFromDashboard() {
        this.searchMovement = this.MovementCodeSelectedFromDashboard;
    }

    get warehouseFiltered() {
        return this.WarehouseList
        .filter(c => (!this.selectedCompanyWarehouseSource || c.id !== this.selectedCompanyWarehouseSource.id))
        .sort((a, b) => a.name.localeCompare(b.name)) as IWarehouse[];
    }

    get warehousesCompanySource() {
        return this.WarehouseList
        .filter(c => (!this.selectedWarehouseCompanyDestination || c.id !== this.selectedWarehouseCompanyDestination.id))
        .sort((a, b) => a.name.localeCompare(b.name)) as IWarehouse[];
    }

    ResetMovement() {
        this.selectedCompanyWarehouseSource = {} as IWarehouse;
        this.selectedWarehouseCompanyDestination = {} as IWarehouse;
        this.date = new Date().toISOString().substr(0, 10);
        let index : number = this.CompanyList.findIndex(c => c.id === this.CompanySourceId);
        if (index !== -1) {
            this.selectedCompanyWarehouseDestination = this.CompanyList[index];
            this.editedItem.idCompanyDestinationWarehouse = this.selectedCompanyWarehouseDestination.id;
            this.editedItem.companyDestinationWarehouseName = this.selectedCompanyWarehouseDestination.name;
        }

        this.selectedStockList = [];
        this.inboundCodeFilter = [];
        this.goodFilter = [];
        this.palletFilter = [];
        this.warehouseNameFilter = [];
        this.bestBeforeDateFilter = [];
        this.searchMovement = "";
        this.selectedInboundCode = "";

        this.$emit('resetMovement');
    }

    editMovement(item: any, dbox = true) {
        if (this.selectedMovement.length > 0) {
            this.$emit('getStockCompany');
            this.editedIndex = this.MovementList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.date = moment(new Date(item.date)).format('YYYY-MM-DD');
            this.selectedCompanyWarehouseDestination = this.CompanyList.find(p => p.id === this.editedItem.idCompanyDestinationWarehouse)!;
            this.selectedWarehouseCompanyDestination = this.WarehouseList.find(p => p.id === this.editedItem.idWarehouseDestination)!;
            this.selectedCompanyWarehouseSource = this.WarehouseList.find(p => p.id === this.editedItem.idWarehouseSource)!;

            // 🔹 Nuevo comportamiento
            if (item.idCustomer) {
                const inboundFromCustomer = this.StockCompanyList.find(s => s.idCustomer === item.idCustomer);
                if (inboundFromCustomer) {
                    this.selectedInboundCode = inboundFromCustomer.codeInbounds;
                    this.isInboundLocked = true;
                }
            } else {
                this.selectedInboundCode = "";
                this.isInboundLocked = false;
            }

            this.dialog = true;
        }
    }

    saveMovementDetails() {
        // Validamos los campos del formulario
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            // Verificamos que haya stock seleccionado o se esté editando un movimiento existente
            if (this.selectedStockList.length > 0 || this.editedItem.id !== "") {
                // Validación: el usuario debe seleccionar un inbound
                if (!this.selectedInboundCode) {
                    this.showMessageWarning("Please select an inbound to move stock from.");
                    return;
                }

                // Validación: todos los pallets deben pertenecer al mismo inbound
                const inboundCodes = new Set(this.selectedStockList.map(s => s.codeInbounds));
                if (inboundCodes.size > 1) {
                    this.showMessageWarning("You can only move items from a single inbound per movement.");
                    return;
                }

                // Validación: debe seleccionarse una empresa destino
                if (!this.selectedCompanyWarehouseDestination || !this.selectedCompanyWarehouseDestination.id) {
                    this.showMessageWarning("Please select a company destination.");
                    return;
                }

                // Validación: debe seleccionarse un almacén destino
                if (!this.selectedWarehouseCompanyDestination || !this.selectedWarehouseCompanyDestination.id) {
                    this.showMessageWarning("Please select a warehouse destination.");
                    return;
                }

                // Validación: debe seleccionarse un almacén origen
                if (!this.selectedCompanyWarehouseSource || !this.selectedCompanyWarehouseSource.id) {
                    this.showMessageWarning("Please select a warehouse source.");
                    return;
                }

                // Asignamos campos al objeto del movimiento
                this.editedItem.idCompanySourceWarehouse = this.CompanySourceId;
                this.editedItem.idWarehouseSource = this.selectedCompanyWarehouseSource.id;
                this.editedItem.companySourceWarehouseName = this.selectedCompanyWarehouseSource.name;

                this.editedItem.idCompanyDestinationWarehouse = this.selectedCompanyWarehouseDestination.id;
                this.editedItem.companyDestinationWarehouseName = this.selectedCompanyWarehouseDestination.name;

                this.editedItem.idWarehouseDestination = this.selectedWarehouseCompanyDestination.id;
                this.editedItem.warehouseDestinationName = this.selectedWarehouseCompanyDestination.name;
                this.editedItem.idCustomer = this.StockCompanyList.find(s => s.codeInbounds === this.selectedInboundCode)!.idCustomer || "";
                // Fecha del movimiento
                this.editedItem.date = new Date(this.date);

                // Si el código está vacío, podemos generar uno por defecto
                if (this.selectedInboundCode && this.selectedInboundCode.trim() !== "") {
                    this.editedItem.code = this.selectedInboundCode.trim();
                }

                // Emitimos el evento hacia el padre con los datos
                this.$emit("saveMovement", this.editedItem, this.selectedStockList);

                // Cerramos el diálogo y limpiamos
                this.close();
            } else {
                this.showMessageWarning("Please select stock to move between warehouses.");
            }
        } else {
            this.showMessageWarning("All required fields must be filled out.");
        }
    }

    deleteMovement (movement: IGoodsMovements) {
        if (this.selectedMovement.length > 0) {
            this.$emit('deleteMovement', movement);
            this.close();
        }
    }
     
    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            this.selectedCompanyWarehouseDestination = {} as ICompany;
            this.selectedStockList = [];
        });
    }

    get bestBeforeDates() : Date[] {
        return uniq(
            this.StockCompanyList
            .filter(b => b.bestBeforeDate !== null && b.idWarehouse === this.selectedCompanyWarehouseSource.id)
            .map(b => b.bestBeforeDate)
        );
    }

    get warehouseNames() : string[] {
        return uniq(
            this.StockCompanyList
            .filter(b => b.warehouseName !== null && b.idWarehouse === this.selectedCompanyWarehouseSource.id)
            .map(b => b.warehouseName)
        );
    }

    get inboundCodes() : string[] {
        return uniq(
            this.StockCompanyList
            .filter(b => b.codeInbounds !== null && b.idWarehouse === this.selectedCompanyWarehouseSource.id)
            .map(b => b.codeInbounds)
        );
    }

    get goodNames() : string[] {
        return uniq(
            this.StockCompanyList
            .filter(b => b.goodName !== null && b.idWarehouse === this.selectedCompanyWarehouseSource.id)
            .map(b => b.goodName)
        );
    }

    get palletNames() : string[] {
        return uniq(
            this.StockCompanyList
            .filter(b => b.listPalletName !== null && b.idWarehouse === this.selectedCompanyWarehouseSource.id)
            .map(b => b.listPalletName)
        );
    }

    get totalCasesSelected(): number {
        return this.selectedStockList.reduce((sum, item) => sum + (item.totalCases || 0), 0);
    }

    get totalGoodsSelected(): number {
        return this.selectedStockList.reduce((sum, item) => sum + (item.totalGoods || 0), 0);
    }

    get stockItemsFiltered(): IStock[] {
    // 🚫 Si no se ha seleccionado un inbound, no mostrar nada
        if (!this.selectedInboundCode || this.selectedInboundCode.trim() === "") {
            return [];
        }

        // Filtra solo el stock del inbound seleccionado
        let filteredList = this.StockCompanyList.filter(
            b => b.codeInbounds === this.selectedInboundCode
        );

        // Filtros adicionales si están activos
        if (this.inboundCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeFilter.includes(b.codeInbounds));
        }
        if (this.goodFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodFilter.includes(b.goodName));
        }
        if (this.palletFilter.length > 0) {
            filteredList = filteredList.filter(b => this.palletFilter.includes(b.listPalletName));
        }
        if (this.selectedCompanyWarehouseSource!.id) {
            filteredList = filteredList.filter(b => b.idWarehouse === this.selectedCompanyWarehouseSource.id);
        }
        if (this.bestBeforeDateFilter.length > 0) {
            filteredList = filteredList.filter(b => this.bestBeforeDateFilter.includes(b.bestBeforeDate));
        }

        return filteredList;
    }

    select(item : IGoodsMovements) : void {
        let index : number = this.selectedMovement.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedMovement = [item];
            this.$emit('input', item);
        } else {
            let movements = this.selectedMovement.find(w => w.id === item.id);
            if (!movements) {
                this.selectedMovement = [];
                this.$emit('input', null);
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
